import { format } from 'date-fns'

import { EMPTY_LIST, SYMBOL_HYPHEN } from '../../../../../constants/common'
import { DATE_SHORT_FORMAT } from '../../../../../constants/date'
import { toUkTimezoneDate } from '../../../../../utils/date'
import {
  getHasListingPublicationPublicUrl,
  getListingPortalLabel,
  LISTING_PUBLICATION_SYNC_STATUSES,
  LISTING_PUBLICATION_UNKNOWN_SYNC_STATUS,
} from '../../../../RentalPortalListing'

function getListingPortalStatus(syncStatus) {
  return (
    LISTING_PUBLICATION_SYNC_STATUSES[syncStatus] ??
    LISTING_PUBLICATION_UNKNOWN_SYNC_STATUS
  )
}

export function getListingPortalPublications(listingData) {
  return (
    (listingData?.permissions?.can_view_publications &&
      listingData.portal_publications) ||
    EMPTY_LIST
  )
}

export function getListingPortalStatuses(syncStatus) {
  return LISTING_PUBLICATION_SYNC_STATUSES[syncStatus]
    ? LISTING_PUBLICATION_SYNC_STATUSES
    : { [syncStatus]: LISTING_PUBLICATION_UNKNOWN_SYNC_STATUS }
}

export function getListingPortalDateText({ publication, t, timezone }) {
  if (publication.published_at) {
    return t('RentalPortal.ListingProfilePortalPublishedOnKey', {
      date: format(
        toUkTimezoneDate(publication.published_at, timezone),
        DATE_SHORT_FORMAT
      ),
    })
  }

  if (publication.scheduled_publish_at) {
    return t('RentalPortal.ListingProfilePortalScheduledForKey', {
      date: format(
        toUkTimezoneDate(publication.scheduled_publish_at, timezone),
        DATE_SHORT_FORMAT
      ),
    })
  }

  return SYMBOL_HYPHEN
}

export function getListingPortalTooltip({ publication, t }) {
  return getHasListingPublicationPublicUrl(publication)
    ? t('RentalPortal.ListingProfilePortalOpenAdTooltipKey', {
        portal: getListingPortalLabel(publication.portal),
      })
    : t('RentalPortal.ListingProfilePortalNoLinkTooltipKey', {
        status: t(getListingPortalStatus(publication.sync_status).text),
      })
}
